import {Pipe, PipeTransform} from '@angular/core'

@Pipe({
    name: 'phone'
})
export class PhonePipe implements PipeTransform{
    transform(value, args) {
    	if(value != null) {
    		var city = value.slice(0, 3);
        	var number = value.slice(3);
        	number = number.slice(0, 3) + '-' + number.slice(3);

        	return ("(" + city + ") " + number).trim();
    	}
    	return null;
    }
}


// WEBPACK FOOTER //
// ./src/app/pipes/phone.pipe.ts